export const TRACK_ORDER = 'TRACK_ORDER';
export const TRACK_ORDER_HISTORY = 'TRACK_ORDER_HISTORY';
export const SAVE_TRACK_ORDER = 'SAVE_TRACK_ORDER';
export const CLEAR_TRACK_ORDER = 'CLEAR_TRACK_ORDER';
export const UPDATE_MAP_URL = 'UPDATE_MAP_URL';
export const TRACKER_STATUS = {
  CONFIRMED: 1,
  BEING_BAKED: 2,
  DISPATCHED: 4,
  CANCELLED: 5,
  DELIVERED: 9
};
export const API_HIT_INTERVAL = 10; // in seconds
export const API_HIT_TIME = 90; // in seconds
export const SHOW_POPUP_CONENT = 'SHOW_POPUP_CONENT';
export const TRACK_ON_MAP = 'TRACK_ON_MAP';
export const SHOW_CHEESY_REWARD_CONFETTI = 'SHOW_CHEESY_REWARD_CONFETTI';
